<template>
  <div class="home">
    <h1>Welcome OMS</h1>
    <img src="https://media1.giphy.com/media/SiEF80pqzJHhM3dOw0/giphy.gif?cid=790b76117490313a4e3b3e1c8637e1ca26ccefd17045ddcf&rid=giphy.gif" alt="">
    <!-- <video autoplay muted loop id="myVideo">
      <source src="../assets/shiba-screen.mp4" type="video/mp4">
    </video>
    <div class="content">
      <h1 style="font-size:40px;">สวัสดีเรา OMS เอง</h1>
    </div>
  </div> -->
  </div>
</template>

<script>

export default {
    name: 'overview'
}
</script>

<style scoped>
#myVideo {
  position: fixed;
  right: 0;
  min-width: 100%;
  min-height: 100%;
}
.content {
  position: fixed;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #f1f1f1;
  width: 100%;
  padding: 20px;
}

</style>
